import React from 'react'

function Comparison() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Receitas tradicionais vs. Método Massa Perfeita™
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Tradicional */}
          <div className="bg-[#F3EEE3] rounded-[20px] p-8 md:p-10 border border-[#49352B]/15 animate-fade-up relative">
            <span className="absolute top-6 right-6 md:top-8 md:right-8 px-3 py-1.5 rounded-full bg-[#49352B]/10 text-[#49352B]/70 text-xs font-semibold">❌ Receita comum</span>
            <div className="rounded-[20px] overflow-hidden mb-6 h-56">
              <img
                src="https://static.lumi.new/97/9798c9b88637cfd5b42c02ee4b4da075.png"
                alt="Pão tradicional seco"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="font-display text-2xl font-bold text-[#49352B] mb-5">Receitas tradicionais</h3>
            <ul className="space-y-3">
              {[
                'Pão seco',
                'Massa pesada',
                'Pizza dura',
                'Croissant sem camadas',
                'Bolo sem textura',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-[#49352B]/70">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#49352B]/40 mt-2.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Massa Perfeita */}
          <div className="bg-gradient-to-br from-[#EBD9C3] to-[#FCFAF5] rounded-[20px] p-8 md:p-10 border-2 border-[#D9891B] shadow-2xl animate-fade-up relative">
            <span className="absolute top-6 right-6 md:top-8 md:right-8 px-3 py-1.5 rounded-full bg-[#D9891B] text-white text-xs font-semibold shadow-md">✔ Método validado</span>
            <div className="rounded-[20px] overflow-hidden mb-6 h-56">
              <img
                src="https://static.lumi.new/95/95a78be57ee5a7fcd0ea5ee66e280dca.png"
                alt="Pão macio Método Massa Perfeita"
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="font-display text-2xl font-bold text-[#49352B] mb-5">Método Massa Perfeita™</h3>
            <ul className="space-y-3">
              {[
                'Massa leve',
                'Miolo aerado',
                'Pizza macia',
                'Croissant folhado',
                'Sabor de padaria',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-[#49352B] font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#D9891B] mt-2.5 flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center animate-fade-up max-w-2xl mx-auto bg-[#EBD9C3]/40 border border-[#D9891B]/30 rounded-[20px] p-6 md:p-8">
          <p className="font-display text-[#D9891B] font-bold text-lg mb-2">E o melhor...</p>
          <p className="text-[#49352B]/80 text-lg leading-relaxed">
            Ninguém percebe que as receitas são sem glúten, sem lactose e sem açúcar refinado.{' '}
            <span className="font-semibold text-[#49352B]">Porque simplesmente têm gosto de comida de verdade.</span>
          </p>
        </div>
      </div>
    </section>
  )
}

export default Comparison
